import { StationeryProduct } from '@shared/utils/print-price/types';
import { clone } from 'lodash-es';

// Required to keep ts linter happy.
// filter(p => !!p) doesn't assert strongly enough
const isProduct = (input: unknown): input is StationeryProduct => {
  return !!input;
};

// Injects product data to an arbitrary object with productIDs
// to provide full type data from a list of types.
export const injectProducts = <T extends object & { productIds: string[] }>(templates: T[], products: StationeryProduct[]): (T & { products: StationeryProduct[] })[] => {
  const productsMap = new Map<string, StationeryProduct>(products.map(product => [product.id, product]));

  // Map all template productIDs to a full product from hashmap
  return templates.map(template => {
    const newTemplate = clone(template) as T & { products: StationeryProduct[] };
    // convert products from ID to full product
    newTemplate.products = template.productIds.map(id => productsMap.get(id)).filter(isProduct);
    return newTemplate;
  });
};
